import React, { useState } from 'react';
import Footer from '../components/Footer';
import BrochureForm from "../components/EnquiryForm";
import CTAButtons from "../components/sticky-button";
import Navbar from "../components/navbar";
import PageHeader from '../about/PageHeader';
import './facultymembers.css';

// --- Shared & Mobile Icons ---
const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="mob-icon text-blue">
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
  </svg>
);

const FilterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="mob-icon text-blue">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-9a3 3 0 11-6 0 3 3 0 016 0zm7.5 0a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const UserAvatarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-avatar-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
  </svg>
);

const HatIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-grid-icon desk-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
  </svg>
);

const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-grid-icon desk-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
  </svg>
);

const BriefcaseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-grid-icon desk-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z" />
  </svg>
);

const RibbonIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-grid-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
  </svg>
);

const UserOutlineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mob-grid-icon desk-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
  </svg>
);

// --- Desktop Table Header Icons ---
const ShieldCheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="desk-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
  </svg>
);

const BankIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="desk-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z" />
  </svg>
);

const StarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="desk-icon">
    <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="desk-icon text-blue">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
  </svg>
);

const FacultyTable = () => {
const facultyData = [
  { srNo: 1, name: "Dr. Pravin Gundalwar", designation: "Director", qualification: "Ph.D.", dateOfJoining: "30/10/2025", status: "Regular" },
  { srNo: 2, name: "Prof. Sonu Gupta", designation: "Deputy Director", qualification: "MCA", dateOfJoining: "07/07/2005", status: "Regular" },
  { srNo: 3, name: "Dr. Rajesh Kapur", designation: "Professor", qualification: "Ph.D.", dateOfJoining: "13/05/2024", status: "Regular" },
  { srNo: 4, name: "Dr. Ashwini Renavikar", designation: "Professor", qualification: "Ph.D.", dateOfJoining: "09/07/2024", status: "Regular" },
  { srNo: 5, name: "Ms. Sunita Pachpute", designation: "Professor of Practice", qualification: "B. E.(Electronics)", dateOfJoining: "01/09/2026", status: "Regular" },
  { srNo: 6, name: "Dr. Padma Mishra", designation: "Associate Professor", qualification: "Ph.D.", dateOfJoining: "12/10/2021", status: "Regular" },
  { srNo: 7, name: "Dr. Sonal Sharma", designation: "Associate Professor", qualification: "Ph.D.", dateOfJoining: "12/09/2024", status: "Regular" },
  { srNo: 8, name: "Dr. Aaditya Desai", designation: "Associate Professor", qualification: "Ph.D.", dateOfJoining: "01/06/2026", status: "Regular" },
  { srNo: 9, name: "Ms. Rani Singh", designation: "Associate Professor of Practice", qualification: "MCM", dateOfJoining: "13/02/2024", status: "Regular" },
  { srNo: 10, name: "Ms. Kinjal Doshi", designation: "Assistant Professor, HoD Academics", qualification: "MCA", dateOfJoining: "08/07/2019", status: "Regular" },
  { srNo: 11, name: "Ms. Rupali Jadhav.", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "17/08/2010", status: "Regular" },
  { srNo: 12, name: "Ms. Aprajita Singh", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "14/07/2008", status: "Regular" },
  { srNo: 13, name: "Ms. Rashmi Vipat", designation: "Assistant Professor, Exam Incharge", qualification: "MCA", dateOfJoining: "02/07/2007", status: "Regular" },
  { srNo: 14, name: "Mr. Shirshendu Maitra", designation: "Assistant Professor", qualification: "MCA, MBA", dateOfJoining: "01/09/2009", status: "Regular" },
  { srNo: 15, name: "Mr. Brijesh Kumar Pandey", designation: "Assistant Professor-TPO", qualification: "MCA,MBA(HR)", dateOfJoining: "05/07/2012", status: "Regular" },
  { srNo: 16, name: "Ms. Mira Gohil", designation: "Assistant Professor", qualification: "M.Phill, MCA", dateOfJoining: "06/09/2023", status: "Regular" },
  { srNo: 17, name: "Ms. Anamika Dhawan", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "15/02/2021", status: "Regular" },
  { srNo: 18, name: "Ms. Shweta M Waghmare", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "15/02/2021", status: "Regular" },
  { srNo: 19, name: "Ms. Rohini Bagul", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "15/02/2021", status: "Regular" },
  { srNo: 20, name: "Ms. Thara C", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "15/02/2021", status: "Regular" },
  { srNo: 21, name: "Ms. Alifiya Mustaque Shaikh", designation: "Assistant Professor", qualification: "MSC", dateOfJoining: "11/04/2022", status: "Regular" },
  { srNo: 22, name: "Dr. Shiksha Dubey", designation: "Assistant Professor", qualification: "Ph.D.", dateOfJoining: "23/01/2024", status: "Regular" },
  { srNo: 23, name: "Mr. Santosh Jain", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "07/02/2024", status: "Regular" },
  { srNo: 24, name: "Ms. Anushri Mukherjee", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "03/07/2025", status: "Regular" },
  { srNo: 25, name: "Ms. Melissa Fernandes", designation: "Assistant Professor", qualification: "MSc.IT", dateOfJoining: "05/01/2026", status: "Regular" },
  { srNo: 26, name: "Ms. Sweety Sahani", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "01/07/2025", status: "Regular" },
  { srNo: 27, name: "Ms. Vaishnavi Biradar", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "06/11/2025", status: "Regular" },
  { srNo: 28, name: "Mr. Shubham Mishra", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "11/03/2024", status: "Regular" },
  { srNo: 29, name: "Ms. Ariba Akhtar", designation: "Assistant Professor", qualification: "MCA", dateOfJoining: "03/08/2026", status: "Regular" },
  { srNo: 30, name: "Ms. Kiran Dubey", designation: "Librarian ", qualification: "M.Phil in Library Science", dateOfJoining: "16/01/2009", status: "Regular" }
];
  const [showForm, setShowForm] = useState(false);

  const getStatusClass = (status) => {
    switch (status) {
      case 'Regular': return 'status-badge-approved';
      case 'Contractual': return 'status-badge-temp';
      case 'In Process': return 'status-badge-process';
      default: return 'status-badge-default';
    }
  };

  return (
    <>
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />
      
      <div className="desktop-only">
        <PageHeader 
          title="List of Faculty Members" 
          crumbs={[{ label: 'Home', href: '/' }, { label: 'List of Faculty Members' }]} 
        />
      </div>

      <main className="faculty-page-main">
        
        {/* ======================================================== */}
        {/* DESKTOP VIEW */}
        {/* ======================================================== */}
        <div className="faculty-content-section desktop-only">
          <div className="faculty-table-wrapper">
            <table className="tims-faculty-table">
              <thead>
                <tr>
                  <th><div className="th-content"><span className="hashtag desk-icon">#</span> SR. NO.</div></th>
                  <th><div className="th-content"><UserOutlineIcon /> NAME OF THE TEACHER</div></th>
                  <th><div className="th-content"><BriefcaseIcon /> DESIGNATION</div></th>
                  <th><div className="th-content"><HatIcon /> QUALIFICATION</div></th>
                  <th><div className="th-content"><CalendarIcon /> DATE OF JOINING</div></th>
                  <th><div className="th-content"><ShieldCheckIcon /> REGULAR / CONTRACTUAL</div></th>
                </tr>
              </thead>
              <tbody>
                {facultyData.map((faculty) => (
                  <tr key={faculty.srNo}>
                    <td className="center-text">{faculty.srNo}</td>
                    <td className="fw-bold">{faculty.name}</td>
                    <td className="fw-bold">{faculty.designation}</td>
                    <td className="fw-bold">{faculty.qualification}</td>
                    <td className="fw-bold">{faculty.dateOfJoining}</td>
                    <td>
                      <span className={`faculty-status-badge ${getStatusClass(faculty.status)}`}>
                        {faculty.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
 

          </div>
        </div>

        {/* ======================================================== */}
        {/* MOBILE VIEW */}
        {/* ======================================================== */}
        <div className="mobile-only mobile-faculty-container">
          
          <div className="mob-page-header">
             <div className="mob-breadcrumb">
                <span className="mob-home-icon">🏠</span> Home {'>'} List of Faculty Members
             </div>
             <h1 className="mob-main-title">List of Faculty Members</h1>
          </div>

          <div className="mob-cards-wrapper">
            {facultyData.map((faculty) => (
              <div key={faculty.srNo} className="mob-faculty-card">
                
                <div className="mob-card-header">
                  <div className="mob-avatar"><UserAvatarIcon /></div>
                  <div className="mob-name-box">
                    <h3 className="mob-name">{faculty.srNo}. {faculty.name}</h3>
                    <p className="mob-designation">{faculty.designation}</p>
                  </div>
                  <div className="mob-badge-box">
                    <span className={`mob-badge ${getStatusClass(faculty.status)}`}>
                      {faculty.status}
                    </span>
                  </div>
                </div>

                <div className="mob-card-grid">
                  <div className="mob-grid-item mob-border-r">
                    <div className="mob-item-label"><HatIcon /> Qualification</div>
                    <div className="mob-item-value">{faculty.qualification}</div>
                  </div>
                  <div className="mob-grid-item">
                    <div className="mob-item-label"><CalendarIcon /> Date of Joining</div>
                    <div className="mob-item-value">{faculty.dateOfJoining}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>

      </main>
      <Footer />
    </>
  );
};

export default FacultyTable;